import { ROUTES } from '@/consts/routes';
import { env } from '@/env/env';
import { SSO_ERROR_KEY } from '@/features/auth/shared/consts/clerk';

// Hard-navigate instead of soft navigate() so the login page gets a completely
// fresh Clerk SDK state (full SDK re-init, fresh __client fetch from Clerk's API,
// no stale in-memory nonce/transferable state). Error is persisted in sessionStorage
// so the login page can toast it after reinitialisation.
// VITE_BASE_URL prefix is required because window.location ignores React Router's basename.
export const redirectToLogin = (errorMessage: string): void => {
  sessionStorage.setItem(SSO_ERROR_KEY, errorMessage);
  window.location.replace(`${env.VITE_BASE_URL}${ROUTES.auth.login}`);
};
